module.exports = __webpack_public_path__ + "static/media/iconMailSuccess.67ec8a3e.svg";